module.exports = __webpack_public_path__ + "static/merrenoloth-74d24ecc433a93514bbe51b580ee21c4.png";